import { useQuery } from '@tanstack/react-query';

import { listMcpServers } from '@/services/mcp-servers';

// Read-only on purpose: the MCP Servers page provisions the org's gateway
// when an admin opens it, which a page any member can open must not trigger.
export const useMcpServerCatalog = (
  orgId: string | undefined,
  enabled: boolean,
) =>
  useQuery({
    queryKey: ['mcp-servers', orgId, 'catalog'],
    queryFn: async () => {
      const response = await listMcpServers(orgId!);
      if (response.detail) throw new Error(response.detail);
      return response.data?.servers ?? [];
    },
    enabled: enabled && !!orgId,
    staleTime: 60_000,
  });
